import Question from "../types/funnelback/Question";

const getQuestionInputParameter = (
    question: Question | null | undefined,
    key: string
): string | undefined => {
    const value = question?.inputParameters?.[key]?.[0]?.trim();
    return value || undefined;
};

export default getQuestionInputParameter;
